import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const Header = () => {
  const navRef = useRef(null);

  useEffect(() => {
    // Nav entrance animation (Slide down + Fade)
    gsap.fromTo(navRef.current, 
      { y: -100, opacity: 0 }, 
      { y: 0, opacity: 1, duration: 1.2, ease: "power4.out", delay: 0.2 }
    );
  }, []);

  return (
    <nav className="navbar-container" ref={navRef}>
      <div className="navbar-glass">
        {/* Logo Section */}
        <div className="nav-logo">
          <img src="/logo/axepertlogo.png" alt="AE Logo" />
        </div>

        {/* Links Section */}
        <ul className="nav-links">
          <li><a href="#home" className="active">Home</a></li>
          <li><a href="#about">About</a></li>
          <li className="dropdown">
            <a href="#segments">Segments </a>
          </li>
          <li><a href="#blog">Blog</a></li>
        </ul>

        {/* Action Button */}
        <div className="nav-button">
          <button className="btn-contact">Contact Us</button>
        </div>
      </div>
    </nav>
  );
};

export default Header;